import React from "react";

import { useTranslation } from "../../../../../../hooks";

interface MarketListItemRowProps {
  label: string;
  className?: string;
  value: string | number | React.ReactNode;
}

export const MarketListItemRow: React.FC<MarketListItemRowProps> = ({label, value, className}) => {
  const t = useTranslation();

  return (
    <div className="bet-row-wrp">

        <div className="bet-row-inner">
          <span className="stake-cont">{`${t(label)}:`}</span>
        </div>

      <div className="bet-row-result">
        <span className={`cof-bet ${className}`}>{value}</span>
      </div>
    </div>
  );
};
